module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[39]526.c24a23d.woff2";